import { IconLoader, Select } from '@ui/src';
import TopUpInstructionItem from './top-up-item';
import { TopUpPanelTypes } from './types';

import cn from './messages.module.css';

const TopUpPanel = ({
  selectedTopUpId,
  setSelectedTopUpId,
  topUpOptions,
  topUpCurrency,
  setTopUpCurrency,
  currencies,
  baseCurrency,
  topUpAccount,
  setTopUpAccount,
  topUpAccounts,
  instructionsIsLoading,
  topUpInstructions,
  getTopUpInstructionPdf,
  pdfDownloadInProgress,
  selectedInstructionType,
}: TopUpPanelTypes) => {
  const filteredCurrencies = currencies?.filter(
    (item) => item.value !== baseCurrency?.id,
  );

  filteredCurrencies?.unshift({
    name: baseCurrency?.name as string,
    value: baseCurrency?.id as string,
    suffix: baseCurrency?.description,
  });

  return (
    <>
      <div className={cn.topupRowWrapper}>
        <Select
          name="top-up"
          value={selectedTopUpId}
          onChange={(e) => {
            setSelectedTopUpId(e.target.value as string);
          }}
          list={topUpOptions?.map((item) => ({
            name: item.companyName,
            value: item.id,
          }))}
          placeholder="Select the Bank from which the top-up will be made"
          title="Select the Bank from which the top-up will be made"
          fullWidth
        />
      </div>
      <div className={cn.topupRowWrapper}>
        <Select
          name="currency"
          value={topUpCurrency}
          onChange={(e) => setTopUpCurrency(e.target.value as string)}
          list={filteredCurrencies}
          placeholder="Select top-up сurrency"
          title="Select top-up сurrency"
          fullWidth
        />
      </div>
      <div className={cn.topupRowWrapper}>
        <Select
          name="account"
          value={topUpAccount}
          // onChange={(e) => setTopUpAccount(e.target.value as string)}
          onChange={(e) => setTopUpAccount(e.target.value as string)}
          list={topUpAccounts?.map((item) => ({
            name: `${item.description} (${item.account.fullNumber})`,
            value: item.accountId,
          }))}
          placeholder="Select account"
          title="Select a top-up account"
          disabled={Boolean(!topUpAccounts)}
          fullWidth
        />
      </div>
      {instructionsIsLoading && (
        <div className={cn.instructionsLoader}>
          <IconLoader />
        </div>
      )}
      {topUpInstructions && !instructionsIsLoading && (
        <div className={cn.topupInstructionsWrapper}>
          {topUpInstructions.items.map((item, index) => (
            <TopUpInstructionItem
              key={item.paymentType}
              instruction={item}
              index={index}
              getTopUpInstructionPdf={getTopUpInstructionPdf}
              pdfDownloadInProgress={pdfDownloadInProgress}
              selectedInstructionType={selectedInstructionType}
            />
          ))}
          {topUpInstructions && !topUpInstructions.items.length && (
            <div className={cn.emptyMessage}>No Top-Up Instructions yet</div>
          )}
        </div>
      )}
    </>
  );
};

export default TopUpPanel;
